export default __webpack_public_path__ + "static/media/hall3.f4f63060.jpeg";